import {connect} from 'react-redux';
import {IntlProvider, addLocaleData} from 'react-intl';

import Locales from 'constants/Locales';

import ru from 'react-intl/locale-data/ru';
import en from 'react-intl/locale-data/en';
import uz from 'react-intl/locale-data/uz';
import kk from 'react-intl/locale-data/kk';

import ruMessages from '../localization/ru.json';
import enMessages from '../localization/en.json';
import uzMessages from '../localization/uz.json';
import kkMessages from '../localization/kk.json';

const localeMessagesMap = {
    ['ru']: ruMessages,
    ['en']: enMessages,
    ['uz']: uzMessages,
    ['kk']: kkMessages
};

addLocaleData(ru);
addLocaleData(en);
addLocaleData(uz);
addLocaleData(kk);

function select(state) {
    const locale = Locales[state.application.get('languageId')];
    const messages = localeMessagesMap[locale];

    return {
        locale,
        messages
    };
}

export default connect(select)(IntlProvider);



// WEBPACK FOOTER //
// ./js/sport-betting/components/LocaleProvider.js